import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const iseloWebReduxStore = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk)), // CSV of middlewares
);

export default iseloWebReduxStore;
